import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { VaduCnpjDetailsResponse } from '@/common/types/vaduCnpjDetails.type'
import { useMutation } from '@tanstack/react-query'

interface UseVaduCnpjDetailsProps {
  onSuccess?: (response: VaduCnpjDetailsResponse) => void
  onError?: (error: ErrorResponse) => void
}

export const useVaduCnpjDetails = ({ onSuccess, onError }: UseVaduCnpjDetailsProps = {}) => {
  const privateAxios = usePrivateAxios()

  return useMutation<VaduCnpjDetailsResponse, ErrorResponse, string>({
    mutationKey: ['vaduCnpjDetails'],
    mutationFn: (cnpj: string) => privateAxios.get(`/external/vadu/cnpj_details/${cnpj}`),
    onSuccess,
    onError,
  })
}
